<template>
    <div v-if="!loadingPage" class="pb-2">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="text-primary mb-2">مواد اولیه</h3>
            <div v-if="isAdminIdentityVerified" class="d-flex justify-content-md-end justify-content-center mb-2">
                <b-button @click="showModalCreate" :disabled="!categories.length" variant="primary" class="px-3">
                    ایجاد
                </b-button>
            </div>
        </div>
        <div v-if="isAdminIdentityVerified">
            <b-row class="mb-2 mb-md-50">
                <b-col lg="3" md="4" class="mt-25">
                    <b-form-group label="نام" label-for="searchTermId">
                        <b-form-input v-model="parameters.searchTerm" dir="rtl" id="searchTermId" class="text-center"
                            autocomplete="off" name="searchTermId" />
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="4" class="mt-25">
                    <b-form-group label="انبار" label-for="warehouseId">
                        <v-select v-model="parameters.warehouseId" :searchable="false" id="warehouseId" dir="rtl"
                            :options="warehouses" autocomplete="off" class="bg-white" style="border-radius: 6px;"
                            :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="4" class="mt-25">
                    <b-form-group label="دسته" label-for="categoryId2">
                        <v-select v-model="parameters.categoryId" :searchable="false" id="categoryId2" dir="rtl"
                            :options="categoriesFilter" autocomplete="off" class="bg-white" style="border-radius: 6px;"
                            :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="4" class="mt-md-2 mt-50">
                    <b-button variant="info" @click="getWarehousingMaterials" :disabled="loading"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                        <span>جستجو</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
            </b-row>
            <b-card class="p-0" no-body>
                <b-overlay v-if="materials.length" :show="loading" variant="transparent" opacity="1" blur="3px"
                    rounded="sm">
                    <b-table responsive :items="materials" :fields="fields" class="mb-0" striped>
                        <template #cell(edit)="data">
                            <feather-icon @click="showModalEdit(data.item)" size="18" icon="EditIcon"
                                class="pointer text-info" color="#8d88a3" />
                        </template>
                        <template #cell(unit)="data">
                            {{ unit_management(data.item.unit) }}
                        </template>
                        <template #cell(category)="data">
                            {{ data.item.category.name }}
                        </template>
                        <template #cell(totalStockQuantity)="data">
                            <span v-b-popover.hover.top="data.item.totalStockQuantity"
                                :title="data.item.unit == 1 ? 'گرم' : data.item.unit == 2 ? 'میلی‌لیتر' : 'عدد'"
                                class="text-info pointer">
                                {{
                                    [1, 2].includes(data.item.unit) ? (data.item.totalStockQuantity / 1000) :
                                        data.item.totalStockQuantity
                                }}
                            </span>
                        </template>
                        <template #cell(description)="data">
                            <span v-if="data.item.description" v-b-popover.hover.top="data.item.description"
                                :title="data.item.name" class="text-info pointer">
                                <feather-icon icon="FileTextIcon" size="20" />
                            </span>
                            <span v-else>
                                -
                            </span>
                        </template>
                        <template #cell(createdAt)="data">
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new
                                    Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                            </span>
                        </template>
                        <template #cell(lastModifiedAt)="data">
                            <span>
                                {{ new Date(data.item.lastModifiedAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new
                                    Date(data.item.lastModifiedAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                            </span>
                        </template>
                    </b-table>
                </b-overlay>
                <div v-else class="text-center py-5">
                    موردی وجود ندارد
                </div>
            </b-card>
            <b-pagination align="center" @input="getWarehousingMaterials" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>

        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>

        <!------------------------------- modal create and edit ------------------------------->
        <b-modal id="warehousing-materials" :title="`${materialsMode}`" centered :hide-footer="true"
            title-class="font-weight-bolder" size="md">
            <div class="p-1">
                <validation-observer ref="warehousingMaterialsValidation">
                    <b-form @submit.prevent>
                        <!------------ categoryId ------------>
                        <b-form-group label="انتخاب دسته" label-for="categoryId" class="text-center">
                            <validation-provider #default="{ errors }" name="دسته" rules="required">
                                <v-select v-model="form.categoryId" :searchable="false" dir="rtl"
                                    :reduce="(value) => value.id" class="bg-white"
                                    :class="errors.length > 0 ? 'border-danger' : null" style="border-radius: 6px;"
                                    label="name" :clearable="false" :options="categories">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- name -->
                        <b-form-group label="نام" label-for="nameId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="nameId" v-model="form.name" name="name"
                                    class="text-center user-select-none" :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!------------ unit ------------>
                        <b-form-group label="واحد اندازه گیری" label-for="unitId" class="text-center">
                            <validation-provider #default="{ errors }" name="واحد اندازه گیری" rules="required">
                                <v-select v-model="form.unit" :searchable="false" dir="rtl"
                                    :reduce="(value) => value.id" class="bg-white"
                                    :class="errors.length > 0 ? 'border-danger' : null" style="border-radius: 6px;"
                                    label="name" :clearable="false" :options="unitmanagement">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- description -->
                        <b-form-group label="توضیحات" label-for="descriptionId" class="text-center">
                            <b-form-textarea rows="3" no-resize autocomplete="off" dir="rtl" id="descriptionId"
                                v-model="form.description" name="description"></b-form-textarea>
                        </b-form-group>

                        <b-button type="submit" variant="primary" @click="managementMaterials" :disabled="loadingButton"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                            <span>{{ materialsMode }}</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { VBPopover, BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BFormTextarea, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner, BBadge } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BBadge,
        vSelect
    },
    directives: {
        'b-popover': VBPopover,
    },
    computed: {
        unit_management() {
            return (status) => {
                if (status == 1) {
                    return 'کیلوگرم'
                }
                if (status == 2) {
                    return 'لیتر'
                }
                if (status == 3) {
                    return 'عدد'
                }
            }
        },
    },
    mixins: [accessHandling],
    data() {
        return {
            required,
            loadingPage: true,
            loading: false,
            loadingButton: false,
            isAdminIdentityVerified: false,
            materials: [],
            categories: [],
            categoriesFilter: [],
            unitmanagement: [
                { name: 'عدد', id: 3 },
                { name: 'گرم / کیلوگرم', id: 1 },
                { name: 'میلی‌لیتر / لیتر', id: 2 }
            ],
            fields: [
                {
                    key: 'name',
                    label: 'نام',
                },
                {
                    key: 'totalStockQuantity',
                    label: 'موجودی کل',
                },
                {
                    key: 'unit',
                    label: 'واحد اندازه گیری',
                },

                {
                    key: 'category',
                    label: 'دسته',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ ایجاد',
                },
                {
                    key: 'lastModifiedAt',
                    label: 'تاریخ آخرین ویرایش',
                },
                {
                    key: 'description',
                    label: 'توضیحات',
                },
                {
                    key: 'edit',
                    label: 'ویرایش',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                categoryId: null,
                searchTerm: null,
                warehouseId: null
            },
            parametersCategories: {
                pageIndex: 1,
                pageSize: 90,
            },
            parametersWarehouses: {
                pageIndex: 1,
                pageSize: 90,
            },
            storeId: null,
            form: {
                name: null,
                description: null,
                unit: null,
                categoryId: null,
            },
            materialsMode: null,
            materialsId: null,
        }
    },
    methods: {
        managementMaterials() {
            if (this.materialsMode == 'ایجاد') {
                this.createWarehousingMaterials()
            }
            if (this.materialsMode == 'ویرایش') {
                this.editWarehousingMaterials()
            }
        },
        showModalEdit(item) {
            if (this.accessHandling('employee', 'warehouse_categories_materials_edit')) {
                this.materialsMode = 'ویرایش'
                this.materialsId = item.id
                this.form.name = item.name
                this.form.description = item.description
                this.form.unit = item.unit
                this.form.categoryId = item.category.id
                this.$bvModal.show('warehousing-materials')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalCreate() {
            if (this.accessHandling('employee', 'warehouse_categories_materials_create')) {
                this.materialsMode = 'ایجاد'
                this.form.name = null
                this.form.description = null
                this.form.unit = null
                this.form.categoryId = null
                this.$bvModal.show('warehousing-materials')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        editWarehousingMaterials() {
            this.$refs.warehousingMaterialsValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    storeService.editWarehousingMaterials(this.storeId, this.materialsId, this.form).then(({ data }) => {
                        this.$refs.warehousingMaterialsValidation.reset();
                        this.$notif({ type: 'success', title: 'ماده با موفقیت ویرایش شد' });
                        this.$bvModal.hide('warehousing-materials')
                        this.getWarehousingMaterials()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        createWarehousingMaterials() {
            this.$refs.warehousingMaterialsValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    storeService.warehousingMaterials(this.storeId, this.form).then(({ data }) => {
                        this.$refs.warehousingMaterialsValidation.reset();
                        this.$notif({ type: 'success', title: 'ماده با موفقیت ایجاد شد' });
                        this.$bvModal.hide('warehousing-materials')
                        this.getWarehousingMaterials()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                if (this.isAdminIdentityVerified) {
                    this.getWarehousingCategories();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        getWarehousingMaterials() {
            this.loading = true
            storeService.getWarehousingMaterials(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.materials = data.items
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.materials = data.items
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
        getWarehousingCategories() {
            storeService.getWarehousingCategories(this.storeId, this.parametersCategories).then(({ data }) => {
                this.categories = data.items
                this.categoriesFilter = [...data.items]
                this.categoriesFilter.unshift({
                    id: null,
                    name: 'نمایش همه'
                })
                this.getWarehousingWarehouses()
            })
        },
        getWarehousingWarehouses() {
            storeService.getWarehousingWarehouses(this.storeId, this.parametersWarehouses).then(({ data }) => {
                this.warehouses = data.items
                this.warehouses.unshift({
                    id: null,
                    name: 'نمایش همه'
                })
                this.getWarehousingMaterials()
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>